<template>
  <div v-if="list_articles && list_articles.length > 0">
    <div class="d-flex flex-start gap align-center bg-spo-blue-grey px-2 py-2 radius-bottom mt-5">
      <v-icon icon="mdi-basket-outline" color="darkblue" size="32"></v-icon>
      <div class="text-h5 font-weight-bold">La boutique</div>
    </div>
    <v-row class="mt-2" align="stretch">
      <v-col cols="12" lg="3" v-for="article in list_articles" :key="article.id">
        <ArticleItem :article="article" class="h-100"></ArticleItem>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import ArticleItem from "@/components/Home/Articles/Article_Item.vue";

export default {
  props: ["module_id"],
  components: { ArticleItem },
  data() {
    return {

    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_articles() {
      return this.mainStore.module.articles_boutique.visibles_accueil;
    }
  },

  methods: {

  },
  async created() {

  },
};
</script>

<style lang="scss" scoped></style>